// angular
import { Component, inject } from '@angular/core';
// utils
import { DialogRef } from '@core/shared/utils/dialog/dialog-ref';
import { DIALOG_DATA } from '@core/shared/utils/dialog/dialog-tokens';

@Component({
  selector: 'pwj-image-preview-dialog',
  standalone: true,
  imports: [],
  templateUrl: './image-preview-dialog.component.html',
  styleUrl: './image-preview-dialog.component.scss',
})
export class ImagePreviewDialogComponent {
  public src!: string;

  private readonly _dialogRef = inject(DialogRef);
  public readonly data: { thumbnail: string } = inject(DIALOG_DATA);

  constructor() {
    this.src = this.data.thumbnail;
  }

  close() {
    this._dialogRef.close();
  }
}
